import { HolidayModelAPI } from '../../../../models';
import { getHolidaysListAdapter } from '../../Adapters/days/Days.adapter';
import { requests } from '../apiAgent';

export const DaysAPI = {
    getDays: () => {
        return requests
            .get('/jerusalem/api/v2.0.0/days')
            .then((response: HolidayModelAPI[]) => getHolidaysListAdapter(response));
    },
};
